module.exports = __webpack_public_path__ + "img/sand-rock-medium-08.d4f98b46.png";